import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
/** Legacy entry point: finish one original receipt, then use the standalone app. */
export function CashMoved({ client, locale = 'az', href }) {
    const text = locale === 'ru' ? {
        title: 'Касса — отдельное приложение', body: 'Учёт денег перенесён в самостоятельное рабочее место кассира.', open: 'Открыть кассу',
        pending: 'Сначала проверьте ранее отправленную операцию. Восстановление использует её исходный номер и параметры.', check: 'Проверить прежнюю операцию', done: 'Результат прежней операции подтверждён.', unavailable: 'Адрес кассы для этого магазина ещё не настроен.',
    } : locale === 'en' ? {
        title: 'Cash is a separate app', body: 'Money management now has its own cashier workspace.', open: 'Open Cash',
        pending: 'Check the previously submitted operation first. Recovery uses its original reference and parameters.', check: 'Check previous operation', done: 'The previous operation is confirmed.', unavailable: 'The Cash app address for this shop is not configured yet.',
    } : {
        title: 'Kassa ayrıca tətbiqdir', body: 'Pul uçotu kassirin ayrıca iş yerinə köçürülüb.', open: 'Kassanı aç',
        pending: 'Əvvəl göndərilmiş əməliyyatı yoxlayın. Bərpa onun ilkin nömrəsi və məlumatları ilə aparılır.', check: 'Əvvəlki əməliyyatı yoxla', done: 'Əvvəlki əməliyyatın nəticəsi təsdiqləndi.', unavailable: 'Bu mağaza üçün Kassa ünvanı hələ qurulmayıb.',
    };
    const [intent, setIntent] = useState(() => client.readIntent());
    const [busy, setBusy] = useState(false), [message, setMessage] = useState('');
    const recover = async () => {
        if (!intent || busy || !client.isCurrent())
            return;
        setBusy(true);
        setMessage('');
        try {
            try {
                const result = await client.commandStatus(intent.command.key);
                if (result.status === 'NOT_FOUND')
                    await client.command(intent.command);
            }
            catch (cause) {
                if (client.failure(cause).status !== 404)
                    throw cause;
                await client.command(intent.command);
            }
            if (!client.isCurrent())
                return;
            client.clearIntent();
            setIntent(null);
            setMessage(text.done);
        }
        catch (cause) {
            if (client.isCurrent())
                setMessage(client.failure(cause).message);
        }
        finally {
            if (client.isCurrent())
                setBusy(false);
        }
    };
    return _jsxs("section", { style: { maxWidth: 560, margin: '32px auto', padding: 24, background: '#fff', borderRadius: 16, border: '1px solid #e2e8f0' }, lang: locale, children: [_jsx("h1", { style: { fontSize: 24, fontWeight: 700 }, children: text.title }), _jsx("p", { style: { margin: '16px 0' }, children: text.body }), intent && _jsxs("div", { children: [_jsx("p", { children: text.pending }), _jsx("button", { type: "button", disabled: busy, onClick: () => void recover(), style: { padding: 12, margin: '16px 0', border: '1px solid #94a3b8', borderRadius: 8 }, children: text.check })] }), message && _jsx("p", { role: "status", children: message }), !intent && (href ? _jsx("a", { href: href, rel: "noreferrer", style: { display: 'inline-block', padding: '12px 18px', background: '#0f766e', color: '#fff', borderRadius: 8 }, children: text.open }) : _jsx("p", { children: text.unavailable }))] });
}
export function standaloneCashUrl(primaryDomain) {
    return primaryDomain === 'agofficial.az' ? 'https://cash.agofficial.az/' : primaryDomain === 'cicekci.az' ? 'https://cash.cicekci.az/' : null;
}
export function standaloneCashAccessUrl(primaryDomain, userId) {
    const href = standaloneCashUrl(primaryDomain);
    if (!href || !/^[a-zA-Z0-9_-]{1,100}$/.test(userId))
        return null;
    return `${href}?accessUserId=${encodeURIComponent(userId)}`;
}
export function standaloneUserManagementUrl(primaryDomain) {
    return primaryDomain === 'agofficial.az' ? 'https://admin.agofficial.az/users' : primaryDomain === 'cicekci.az' ? 'https://admin.cicekci.az/users' : null;
}
